import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=4fafaa6d&scoped=true&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"
import style0 from "./Program.vue?vue&type=style&index=0&id=4fafaa6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fafaa6d",
  null
  
)

export default component.exports